import { Injectable } from '@angular/core';

@Injectable()
export class LzLanguageService {

  private currentLanguage: string;

  public identifyLanguage = () => {
    if (this.currentLanguage) {
      return this.currentLanguage;
    } else {
      try {
        let lang = window.localStorage.getItem('lang');
        this.currentLanguage = (lang) ? lang : 'ua';
      } catch (error) {
        console.log('CAN\'T GET LANGUAGE:', error);
        this.currentLanguage = 'ua';
      }
      return this.currentLanguage;
    }
  }

  public setLanguage = (newLanguage) => {
    try {
      window.localStorage.setItem('lang', newLanguage);
      this.currentLanguage = newLanguage;
      window.location.reload();
    } catch (error) {
      console.log('CAN\'T SAVE NEW LANGUAGE:', error);
    }
  }

}
